export enum THEME_TYPE {
	LIGHT = 'light',
	DARK = 'dark',
}

export interface ITheme {
	colors: {
		primary: string;
		primaryGradient1: string;
		primaryGradient2: string;
		primaryGradient3: string;
		primaryGradient4: string;
		primaryGradient5: string;
		primaryGradient6: string;
		primaryGradient7: string;
		primaryGradient8: string;
		primaryGradient9: string;
		primaryGradient10: string;

		text1: string;
		text2: string;
		text3: string;
		text4: string;
		text5: string;
		text6: string;
		text7: string;
		text8: string;
		text9: string;
		text10: string;
		text11: string;
		text12: string;
		text13: string;
		text14: string;
		text15: string;
		text16: string;
		text17: string;
		text18: string;
		text19: string;
		text20: string;
		text21: string;
		text22: string;
		text23: string;
		text24: string;
		text25: string;
		text26: string;
		text27: string;

		bg1: string;
		bg2: string;
		bg3: string;
		bg4: string;
		bg5: string;
		bg6: string;
		bg7: string;
		bg8: string;
		bg9: string;
		bg10: string;
		bg11: string;
		bg12: string;
		bg13: string;
		bg14: string;
		bg15: string;
		border: string;
		border2: string;
		borderActive: string;
	};

	media: {
		xl: string;
		lg: string;
		md: string;
		sm: string;
	};

	borderRadius: {
		xs: string;
		sm: string;
		md: string;
	};

	durations: {
		ms300: number;
		ms200: number;
	};

	containerWidth: string;
	contentWidth: string;
	headerHeight: string;
	continiueButtonHeight: string;

	space: {
		xl: string;
		lg: string;
		md: string;
		sm: string;
		xs: string;
	};

	fontWeight: {
		extralight: number;
		light: number;
		demi: number;
		regular: number;
		medium: number;
		demibold: number;
		bold: number;
		extrabold: number;
		black: number;
	};
}
